import { gql } from "apollo-boost";

export const AFFILIATE_FIELDS = gql`
  fragment AffiliateConsultFields on affiliateConsult {
      noAffiliate
      fullname
      affiliateCardNumber
      Nss
      affiliateContrat
      birthDate
      status
      statusDesc
      phone
      ErrorNumber
      ErrorMessage
      gender
      Age
      planType
      affiliateId
      Token
      UUIDIdentifier
      interactionid
      seccionNumber
      medicinePlan
      pypProgram
      sessionIdPrimera
      coveragePercentage
      dependentNumber
      eligibilityStatus
      effectiveDate
      expirationDate
      medicinePlanList {
        IdPlan
        NombrePlan
        IdTipoPlan
        TipoPlan
        MontoTope
        Disponible
        FechaRenovacion
      }
      programPyPList {
        CodigoPrograma
        Programa
        CodigoCirculo
        Circulo
      }
  }
`;

export const GET_AFFILIATES = gql`
  query getAffiliates($where: getAffiliateWhereInput!) {
    getAffiliates(where: $where) {
      ...AffiliateConsultFields
    }
  }
  ${AFFILIATE_FIELDS}
`;

export const VALIDATE_AFFILIATE_BMI = gql`
  query validateCoberturaBMI($where: getAffiliateWhereInput!) {
    item: validateCoberturaBMI(where: $where) {
      ...AffiliateConsultFields
    }
  }
  ${AFFILIATE_FIELDS}
`;
